import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: null,
    isLoading: false,
    error: null,
    patientData: null,
};

const doctorTriageSlice = createSlice({
    name: "doctorTriage",
    initialState,
    reducers: {
        setDoctorTriage: (state, action) => {
            state.data = action.payload;
        },
        clearDoctorTriage: (state) => {
            state.data = null;
            state.isLoading = false;
            state.error = null;
        },
        getPatientDoctorTriage: (state, action) => {
            state.patientData = action.payload;
        },
        clearPatientDoctorTriage: (state) => {
            state.patientData = null;
        },
    },
});

export const { 
    setDoctorTriage, 
    clearDoctorTriage, 
    getPatientDoctorTriage,
    clearPatientDoctorTriage
} = doctorTriageSlice.actions;

export default doctorTriageSlice.reducer;